module.exports = __webpack_public_path__ + "static/cover-54f94046900154101cd1f2a4feb6c476.jpg";